import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPause = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.75 5.455c0-.297.311-.705.917-.705h1.666c.606 0 .917.408.917.705v13.09c0 .297-.311.705-.917.705H6.667c-.606 0-.917-.408-.917-.704zm.917-2.205c-1.236 0-2.417.894-2.417 2.205v13.09c0 1.31 1.181 2.205 2.417 2.205h1.666c1.236 0 2.417-.894 2.417-2.204V5.455c0-1.31-1.181-2.205-2.417-2.205zm8.083 2.205c0-.297.311-.705.917-.705h1.666c.606 0 .917.408.917.705v13.09c0 .297-.311.705-.917.705h-1.666c-.606 0-.917-.408-.917-.704zm.917-2.205c-1.236 0-2.417.894-2.417 2.205v13.09c0 1.31 1.181 2.205 2.417 2.205h1.666c1.236 0 2.417-.894 2.417-2.204V5.455c0-1.31-1.181-2.205-2.417-2.205z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPause;
